import { FC, RefObject } from 'react';
import { Filters } from './Filters';

export type FiltersModalProps = {
    container: RefObject<HTMLElement>;
};

export const FiltersModal: FC<React.PropsWithChildren<FiltersModalProps>> = ({
    container
}) => <Filters container={container?.current} />;
